import api from '../api/config';
import { ENDPOINTS } from '../api/endpoints';

/**
 * @typedef {Object} Approval
 * @property {string} id - Approval ID
 * @property {string} status - Approval status
 * @property {Date} date - Approval date
 */

/**
 * Get approvals by company
 * @param {string} company - Company name to fetch approvals for
 * @param {Object} options - Additional options for the request
 * @param {Object} messageApi - Optional message API from MessageProvider for toast notifications
 * @returns {Promise<Approval[]>} Array of approvals
 */
export const getApprovals = async (company, options = {}, messageApi = null) => {
  if (!company) {
    if (messageApi) {
      messageApi.warning('Company name is required', 3);
    }
    return [];
  }

  try {
    const { data } = await api.post(ENDPOINTS.GET_APPROVALS, 
      { company },
      {
        ...options
      }
    );
    
    if (!data) {
      if (messageApi) {
        messageApi.info('No approvals found', 3);
      }
      return [];
    }
    return data;
  } catch (error) {
    if (messageApi) {
      messageApi.error('Failed to fetch approvals', 3);
    }
    return [];
  }
};